import { DataDocument, tagsTemplateDirectoryId } from '@fillip/api';

export const TemplateTagH4: DataDocument = {
  id: 'tag-h4',
  parentId: tagsTemplateDirectoryId,
  info: {
    title: 'Heading 4',
    icon: 'h4',
    isProtected: true,
  },
  element: {
    type: 'element.text',
    textFormat: 'h4',
    textContent: ':$text',
  },
  class: {
    class: ':`${$containerClasses}`',
    elementClass: ':`${$elementClasses}`',
  },
  tag: {
    tag: 'tag',
  },
  tagDefinition: {
    tag: 'h4',
    title: 'Heading 4',
    category: 'content',
    icon: 'h4',
    editor: 'h4',
  },
  interfaceDefinition: {
    title: '',
    inheritFrom: 'baseContent',
    props: [
      {
        title: 'Container Classes',
        key: 'containerClasses',
        type: 'string',
        defaultValue:
          ":`${$$contentTagClasses} ${$$headlineClasses} text-lg${$containerClasses || properties?.containerClasses?.value || ''}`",
      },
      {
        title: 'Element Classes',
        key: 'elementClasses',
        type: 'string',
        defaultValue:
          ":`font-bold ${$elementClasses || properties?.elementClasses?.value || ''}`",
      },
    ],
  },
};
